import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Student} from '../../models/eventRequest';
import {StudentService} from '../../_services/student.service';
import {Router} from '@angular/router';
import {ReadOnlyService} from '../../_services/read-only.service';

@Component({
  selector: 'app-student-list',
  templateUrl: './student-list.component.html',
  styleUrls: ['./student-list.component.css']
})
export class StudentListComponent implements OnInit {

  pageNumber = 0;
  pageSize = 50;
  messageError = '';
  inputSearchName = '';

  @Input()
  iStudents?: Student[];

  @Input()
  iPageStudent: any;

  @Input()
  iIsArchived = false;

  @Input()
  iUseExternalDataFlow = false;

  @Output()
  iPageNumber: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  iSearchTermChanged: EventEmitter<string> = new EventEmitter<string>();


  constructor(public studentService: StudentService, private router: Router, public readOnlyService: ReadOnlyService) {
  }

  /** Nombre d'élèves au statut « À créer » (page Élèves uniquement). */
  toCreateCount = 0;
  onlyToCreate = false;

  ngOnInit(): void {
    if (!this.router.url.match("/admin")) {
      this.getAllStudent();
      if (!this.iIsArchived) {
        this.loadToCreateCount();
      }
    }
  }

  loadToCreateCount() {
    this.studentService.getStudentsToCreate(0, 1).subscribe(page => this.toCreateCount = page?.totalElements ?? 0);
  }

  /** Affiche seulement les élèves « À créer », ou revient à la liste complète. */
  toggleToCreate() {
    this.onlyToCreate = !this.onlyToCreate;
    this.searchStudent(this.inputSearchName, 0);
  }

  ngOnChanges() {
  }

  onSearchChange(input: any) {
    this.inputSearchName = input.value;

    if (this.iUseExternalDataFlow) {
      this.iSearchTermChanged.emit(this.inputSearchName);
      return;
    }

    this.searchStudent(this.inputSearchName, 0);
  }

  consultStudent(id: bigint) {
    this.router.navigate(['students/' + id]);
  }

  searchStudent(name: string, pageNumber: number) {
    const request = this.onlyToCreate && !name
      ? this.studentService.getStudentsToCreate(pageNumber, 20)
      : this.studentService.searchStudentByName(name, pageNumber, this.iIsArchived);
    if (this.onlyToCreate && name) {
      // une recherche par nom porte sur tous les élèves
      this.onlyToCreate = false;
    }
    request.subscribe(
      studentPageable => {
        this.iPageStudent = studentPageable;
        this.iStudents = studentPageable.content;
      },
      err => {
        this.messageError = err;
      }
    );
  }

  getAllStudent() {
    this.studentService.searchStudentByName('', this.pageNumber, this.iIsArchived).subscribe(studentPageable => {
      this.iPageStudent = studentPageable;
      this.iStudents = studentPageable.content;
    });
  }

  onChangeStudentPage($event: number) {
    this.iPageNumber.emit($event);

    if (!this.iUseExternalDataFlow) {
      this.searchStudent(this.inputSearchName, $event);
    }
  }

  getStatusValue(status: string) : string{
    var statusValue = "Non défini";
    switch (status) {
      case "TO_CREATE" : statusValue = "À créer"; break;
      case "IN_PROGRESS" : statusValue = "En cours"; break;
      case "PERMIS_VALIDATED" : statusValue = "Permis obtenu"; break;
      case "FINISH" : statusValue = "A quitté"; break;
      case "CANCEL" : statusValue = "Annulé"; break;
    }
    return statusValue;
  }

  initials(s: Student): string {
    return ((s.firstname || '').charAt(0) + (s.lastname || '').charAt(0)).toUpperCase() || '?';
  }

  /** Couleur d'avatar stable pour un même élève. */
  avatarColor(s: Student): number {
    return Number(s.id || 0) % 6;
  }
}
